import PropTypes from "prop-types";
import clsx from "clsx";
import featureIconData from "../../data/feature-icons/feature-icon-four.json";
import FeatureIconFourSingle from "../../components/feature-icon/FeatureIconFourSingle.js";
import { useAppSelector } from "../../hooks/useReduxMethods";
import GiveawayCard from "./GiveawatCard";
import moment from "moment-timezone";
import { getUserPrefersLang } from "../../shared/helpersMethod";

const FeatureIconFour = ({
  spaceTopClass,
  spaceBottomClass,
  containerClass,
  gutterClass,
  responsiveClass,
  bottomText,
  bgImg,
}) => {
  const { bussinessData } = useAppSelector((state) => state.bussinessData);
  const userLng = getUserPrefersLang();

  const baghdadStart = moment
    .tz("2025-05-07T00:00:00", "Asia/Baghdad")
    .toDate();
  return (
    <div
      className={clsx(
        "support-area hm9-section-padding mt-40 ml-20 mr-20",
        spaceTopClass,
        spaceBottomClass,
        responsiveClass
      )}
      style={
        bgImg
          ? { backgroundImage: `url(${process.env.PUBLIC_URL + bgImg})` }
          : {}
      }
    >
      <div className={clsx(containerClass, gutterClass)}>
        <div className="row- d-flex justify-content-center gap-4 flex-wrap">
          {bussinessData?.countDown?.map((single, key) => (
            <div
              // style={{ maxWidth: "800px", margin: "auto", padding: "20px" }}
              // className="col-lg-6 col-md-6 col-sm-6"
              key={key}
            >
              <GiveawayCard
                image={
                  single.type === "car"
                    ? require("../../assets/images/give-away-car.png")
                    : require("../../assets/images/give-away-iphone.png")
                }
                title={single.title[userLng]}
                startDate={single.nextDrawDt.date}
                remainingDays={single.days}
                gradient={single.bg_color}
                intervalDays={single.type == "car" ? 30 : 7}
              />
              {/* <FeatureIconFourSingle data={single} spaceBottomClass="mb-10" /> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

FeatureIconFour.propTypes = {
  bgImg: PropTypes.string,
  containerClass: PropTypes.string,
  gutterClass: PropTypes.string,
  responsiveClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default FeatureIconFour;
